import React from 'react';
import PropTypes from 'prop-types';
import { media } from '@amtrav/themes';
import styled from 'styled-components';

const ContentStyled = styled.div`
  max-width: ${({ fullWidth }) => (fullWidth ? 'unset' : '1325px')};

  ${media.Large`
    margin-left: 210px;
  `}
`;

const Content = ({ children, fullWidth }) => <ContentStyled fullWidth={fullWidth}>{children}</ContentStyled>;

Content.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
};

Content.defaultProps = {
  children: undefined,
  fullWidth: false,
};

export default Content;
